function assetUrl(file) {
  return `/assets/${encodeURIComponent(file)}`;
}

/** Main brand mark — public/mainLogo.png */
export const SITE_LOGO = "/mainLogo.png";

export const MARQUEE_WORDS = [
  "Brand Strategy",
  "Social Campaigns",
  "Print Design",
  "Logo Identity",
  "Video Marketing",
  "Packaging",
  "Ad Creatives",
  "Digital Experience",
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const HERO_SLIDES = [
  { image: assetUrl("homeslider1.jpg"), tag: "Brand campaigns" },
  { image: assetUrl("homeslider2.jpg"), tag: "Social media" },
  { image: assetUrl("homeslider3.jpg"), tag: "Print & packaging" },
];

export const ABOUT_FEATURES = [
  { label: "Strategic brand positioning", icon: "brand" },
  { label: "High-impact visual systems", icon: "palette" },
  { label: "Social-first content engines", icon: "share" },
  { label: "Premium print production", icon: "print" },
  { label: "Campaign creative direction", icon: "campaign" },
  { label: "Performance-driven design", icon: "trending" },
];

export const ABOUT_IMAGES = {
  main: assetUrl("ourExpertise.png"),
  secondary: assetUrl("portrait.jpg"),
};

export const ABOUT_CONTENT = {
  eyebrow: "Our Expertise in Creative Advertising",
  headline:
    "We are a full-service creative agency with more than 12 years of experience in delivering superior brand, social, and print campaigns.",
  performance: {
    title: "Performance",
    metrics: [
      { value: "320+", label: "Happy Clients", trend: "up", color: "blue" },
      { value: "850+", label: "Projects", trend: "up", color: "orange" },
    ],
    progress: { label: "Brand Innovation Growth", percent: 92 },
  },
  reviews: [
    {
      rating: "4.9+",
      text: "Trusted by ambitious brands for premium creative and consistent delivery.",
    },
    {
      rating: "850+",
      text: "Successful projects across branding, social media, print, and campaigns.",
    },
  ],
  cta: { label: "Request Quote", href: "#contact" },
};

export const SERVICES_SECTION = {
  eyebrow: "Our Services",
  title: "We will provide awesome services",
  defaultDesc:
    "Establish your brand presence with premium design. Grow your impact through strategic creative work.",
  background: assetUrl("man-desk-with-computer-furniture-picture-frame-plant-room.jpg"),
  featured: {
    image: assetUrl("serviceSlider.jpg"),
    cta: { label: "Request Quote", href: "#contact" },
  },
};

const SERVICE_IMAGE_BASE = "/ourServices";

export const SERVICES = [
  {
    title: "Graphic Designing",
    icon: "brush",
    desc: "Visual systems that elevate every touchpoint.",
    image: `${SERVICE_IMAGE_BASE}/grapgic%20Design.jpg`,
  },
  {
    title: "Social Media Posts",
    icon: "share",
    desc: "Scroll-stopping content for every platform.",
    image: `${SERVICE_IMAGE_BASE}/Social%20media.jpg`,
  },
  {
    title: "Branding",
    icon: "brand",
    desc: "Identity systems built for recognition and trust.",
    image: `${SERVICE_IMAGE_BASE}/Branding.jpg`,
  },
  {
    title: "Logo Design",
    icon: "logo",
    desc: "Memorable marks crafted with strategic intent.",
    image: `${SERVICE_IMAGE_BASE}/logo%20design.jpg`,
  },
  {
    title: "Packaging Design",
    icon: "package",
    desc: "Shelf-ready packaging with premium finish.",
    image: `${SERVICE_IMAGE_BASE}/packaging%20design.jpg`,
  },
  {
    title: "Printing Solutions",
    icon: "print",
    desc: "Offset, digital, and large-format excellence.",
    image: `${SERVICE_IMAGE_BASE}/printing%20solution.jpg`,
  },
  {
    title: "Website Design",
    icon: "web",
    desc: "Conversion-focused digital experiences.",
    image: `${SERVICE_IMAGE_BASE}/web%20design.jpg`,
  },
  {
    title: "Ad Campaign Design",
    icon: "campaign",
    desc: "Campaigns engineered for attention and ROI.",
    image: `${SERVICE_IMAGE_BASE}/ad%20campaign.jpg`,
  },
  {
    title: "Video Marketing",
    icon: "video",
    desc: "Motion stories that amplify your message.",
    image: `${SERVICE_IMAGE_BASE}/video%20marketing.jpg`,
  },
];

export const PORTFOLIO_CATEGORIES = ["All", "Branding", "Social Media", "Print", "Packaging", "Campaigns"];

/** All portfolio images in public/assets (excluding user.png). Keep in sync with folder. */
const PORTFOLIO_ASSET_FILES = [
  "01.jpg",
  "02.jpg",
  "2.jpg",
  "3.jpg",
  "4.jpg",
  "5.jpg",
  "ourExpertise.png",
  "gallery-1.jpg",
  "gallery-2.jpg",
  "gallery-3.jpg",
  "gallery-4.jpg",
  "gallery-5.jpg",
  "campaign1.png",
  "campaign2.png",
  "inceptionLogo.png",
  "logo1.jpg",
  "logo2.jpg",
  "logo3.jpg",
  "logo4.jpg",
  "logo5.jpg",
  "logo6.jpg",
  "logo7.jpg",
  "logo8.jpg",
  "logo9.jpg",
  "logo10.jpg",
  "logo11.jpg",
  "logo12.jpg",
  "man-desk-with-computer-furniture-picture-frame-plant-room.jpg",
  "New Ad Design.jpg",
  "portrait.jpg",
  "serviceSlider.jpg",
  "skills.jpg",
  "socialMedia1.jpg",
  "socialMedia2.jpg",
  "socialMedia3.jpg",
  "socialMedia4.jpg",
  "socialMedia5.jpg",
  "socialMedia6.jpg",
  "socialMedia7.jpg",
  "socialMedia8.jpg",
  "socialMedia9.jpg",
  "socialMedia10.jpg",
  "socialMedia11.jpg",
  "socialMedia12.jpg",
  "socialMedia13.jpg",
  "ST.png",
  "team-5.jpg",
];

function portfolioTitleFromFile(file) {
  const base = file.replace(/\.[^.]+$/, "");
  if (file === "campaign1.png") return "Campaign Creative 1";
  if (file === "campaign2.png") return "Campaign Creative 2";
  if (file === "inceptionLogo.png") return "Inception Logo Mark";
  if (file === "ourExpertise.png") return "Our Expertise";
  if (file === "portrait.jpg") return "Portrait Feature";
  if (file === "skills.jpg") return "Skills Showcase";
  if (file === "serviceSlider.jpg") return "Service Slider Creative";
  if (file === "ST.png") return "Brand Mark ST";
  if (file === "New Ad Design.jpg") return "New Ad Design";
  if (file.includes("man-desk")) return "Creative Workspace";
  if (/^\d+$/.test(base) || /^0\d$/.test(base)) return `Campaign Creative ${base}`;
  const logo = file.match(/^logo(\d+)\./i);
  if (logo) return `Logo Identity ${logo[1]}`;
  const social = file.match(/^socialMedia(\d+)\./i);
  if (social) return `Social Media Creative ${social[1]}`;
  const gallery = file.match(/^gallery-(\d+)\./i);
  if (gallery) return `Gallery Project ${gallery[1]}`;
  const team = file.match(/^team-(\d+)\./i);
  if (team) return `Campaign Visual ${team[1]}`;
  return base.replace(/-/g, " ");
}

function portfolioCategoryFromFile(file) {
  if (
    file === "inceptionLogo.png" ||
    file === "ourExpertise.png" ||
    file === "portrait.jpg" ||
    file === "ST.png" ||
    /^logo\d+\./i.test(file)
  ) {
    return "Branding";
  }
  if (/^campaign\d+\./i.test(file)) return "Campaigns";
  if (/^socialMedia\d+\./i.test(file)) return "Social Media";
  if (/^gallery-\d+\./i.test(file)) {
    const n = Number(file.match(/^gallery-(\d+)/i)?.[1] || 0);
    return n % 2 === 0 ? "Packaging" : "Print";
  }
  if (
    /^team-\d+\./i.test(file) ||
    file === "New Ad Design.jpg" ||
    /^(0?\d+)\.jpe?g$/i.test(file)
  ) {
    return "Campaigns";
  }
  if (file === "skills.jpg" || file === "serviceSlider.jpg" || file.includes("man-desk")) {
    return "Print";
  }
  return "Print";
}

export const PORTFOLIO_ITEMS = PORTFOLIO_ASSET_FILES.map((file, index) => {
  const item = {
    id: index + 1,
    title: portfolioTitleFromFile(file),
    category: portfolioCategoryFromFile(file),
    image: assetUrl(file),
  };
  if (index % 5 === 0) item.tall = true;
  return item;
});

const SOCIAL_ADS_BASE = "/social%26ads";

function socialAdsImage(file) {
  return `${SOCIAL_ADS_BASE}/${encodeURIComponent(file)}`;
}

/** Left slider — all images in public/social&ads */
export const SOCIAL_SLIDER_IMAGES = [
  { label: "Social & Ads 1", file: "social&ads1.jpg", image: socialAdsImage("social&ads1.jpg") },
  { label: "Social & Ads 2", file: "social&ads2.jpg", image: socialAdsImage("social&ads2.jpg") },
  { label: "Social & Ads 3", file: "social&ads3.jpg", image: socialAdsImage("social&ads3.jpg") },
  { label: "Social & Ads 4", file: "social&ads4.jpg", image: socialAdsImage("social&ads4.jpg") },
  { label: "Social & Ads 5", file: "social&ads5.jpg", image: socialAdsImage("social&ads5.jpg") },
  { label: "Social & Ads 6", file: "social&ads6.jpg", image: socialAdsImage("social&ads6.jpg") },
  { label: "Social & Ads 7", file: "social&ads7.jpg", image: socialAdsImage("social&ads7.jpg") },
  { label: "Social & Ads 8", file: "social&ads8.jpg", image: socialAdsImage("social&ads8.jpg") },
];

/** Right grid — featured picks */
export const SOCIAL_GRID_CARDS = [
  { platform: "Instagram", file: "social&ads4.jpg", image: socialAdsImage("social&ads4.jpg") },
  { platform: "Facebook Ads", file: "social&ads5.jpg", image: socialAdsImage("social&ads5.jpg") },
  { platform: "Branding", file: "social&ads6.jpg", image: socialAdsImage("social&ads6.jpg") },
  { platform: "Campaign", file: "social&ads1.jpg", image: socialAdsImage("social&ads1.jpg") },
];

export const TESTIMONIALS = [
  { name: "Sarah Mitchell", role: "CMO, Nova Retail", quote: "Their creative team transformed our brand presence. Campaign performance improved within weeks.", avatar: "SM" },
  { name: "James Chen", role: "Founder, Apex Studio", quote: "Premium design quality with fast turnaround. Exactly what a growing agency partner should feel like.", avatar: "JC" },
  { name: "Elena Rodriguez", role: "Marketing Director", quote: "From social grids to print collateral — cohesive, strategic, and beautifully executed.", avatar: "ER" },
  { name: "David Okonkwo", role: "Brand Manager", quote: "We finally have a visual system that scales across every channel. Outstanding partnership.", avatar: "DO" },
];

export const STATS = [
  { value: 850, suffix: "+", label: "Projects Completed" },
  { value: 320, suffix: "+", label: "Happy Clients" },
  { value: 1200, suffix: "+", label: "Social Campaigns" },
  { value: 12, suffix: "+", label: "Years Experience" },
];

export const PROCESS_STEPS = [
  { step: "01", title: "Strategy", desc: "Research, positioning, and creative direction aligned to your goals." },
  { step: "02", title: "Design", desc: "Visual concepts refined into production-ready brand assets." },
  { step: "03", title: "Content Creation", desc: "Copy, graphics, and motion tailored for each channel." },
  { step: "04", title: "Publishing", desc: "Scheduled rollout with brand-consistent delivery." },
  { step: "05", title: "Marketing", desc: "Optimization, reporting, and continuous creative iteration." },
];

export const GALLERY_IMAGES = [
  "gallery-1.jpg",
  "gallery-2.jpg",
  "gallery-3.jpg",
  "gallery-4.jpg",
  "gallery-5.jpg",
  "socialMedia2.jpg",
  "socialMedia3.jpg",
  "skills.jpg",
].map(assetUrl);

export const CONTACT = {
  email: "info@itsinception.com",
  phone: "+91 814 666 5550",
  address: "Ludhiana, Punjab (India)",
};

export const SOCIAL_LINKS = [
  { label: "Instagram", href: "https://www.instagram.com/", icon: "instagram" },
  { label: "LinkedIn", href: "https://www.linkedin.com/", icon: "linkedin" },
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=100063895480433",
    icon: "facebook",
  },
  { label: "Behance", href: "https://www.behance.net/inceptiondstudio", icon: "behance" },
];

export const FOOTER_LINKS = {
  company: [
    { label: "About Us", href: "#about" },
    { label: "Our Work", href: "#portfolio" },
    { label: "Process", href: "#process" },
    { label: "Contact", href: "#contact" },
  ],
  services: SERVICES.slice(0, 6).map((s) => ({ label: s.title, href: "#services" })),
  social: SOCIAL_LINKS.map(({ label, href }) => ({ label, href })),
};
